import Eyebrow from './Eyebrow'

// PageHeader — eyebrow numerada + display title con itálica interna + acciones.
// Pegado al top del contenedor de página.

export default function PageHeader({ num, kicker, title, italic, sub, actions, className = '' }) {
  return (
    <div className={`px-7 pt-6 pb-5 flex items-end justify-between gap-6 border-b border-[var(--line)] ${className}`}>
      <div className="min-w-0">
        {kicker && <Eyebrow num={num}>{kicker}</Eyebrow>}
        <h1 className="font-display text-[34px] leading-[1.05] mt-2.5 text-[var(--ink)]">
          {title}
          {italic && <> <span className="font-display-i text-[var(--ink-3)]">{italic}</span></>}
        </h1>
        {sub && <p className="text-[13px] text-[var(--ink-3)] mt-1.5 max-w-2xl">{sub}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  )
}
